import React, { useState } from 'react';
import { ExposureWidgetItemBrand } from '../../../../../../../types/widget';
import Img from '../../../../../../../components/Img/Img';
import Slider from '../../../../../../../components/utils/Slider/Slider';
import notFoundImg from '../../../../../../../static/images/common/not-found-img.png';
import { BrandSwipeCardStyle } from './style';

interface BrandSwipeCardProps {
  widgetBrandList?: ExposureWidgetItemBrand[];
}

const BrandSwipeCard = (props: BrandSwipeCardProps): JSX.Element => {
  const { widgetBrandList = [] } = props;

  const [swipeIndex, setSwipeIndex] = useState(0);

  const handleChangeSwipeIndex = (oldIndex: number, newIndex: number): void => {
    setSwipeIndex(newIndex);
  };

  const widgetBrandItem = widgetBrandList[swipeIndex];

  return (
    <BrandSwipeCardStyle>
      <Slider
        className="widget-store-swipe-layout"
        list={widgetBrandList}
        arrows={false}
        beforeChange={handleChangeSwipeIndex}
        infinite={false}
        item={(item: ExposureWidgetItemBrand): JSX.Element => {
          const mainImg = item.attachment?.[0];
          return <Img clickAble={false} src={mainImg?.url || notFoundImg} />;
        }}
      />
      <div className="title">
        {widgetBrandItem?.title ? (
          widgetBrandItem.title
        ) : (
          <span className="require-info">위젯 브랜드 아이템 타이틀을 설정해주세요.</span>
        )}
      </div>
      {widgetBrandItem?.contents && <div className="contents">{widgetBrandItem.contents}</div>}
    </BrandSwipeCardStyle>
  );
};

export default BrandSwipeCard;
